import { useContext } from 'react'
import { RosterSqlSearchContext } from 'recruiter/contexts/RosterSqlSearchContext'

export const useRosterSqlSearch = () => {
    const context = useContext(RosterSqlSearchContext)

    if (!context) {
        throw new Error(
            'useRosterSqlSearch must be used within RosterSqlSearchProvider'
        )
    }

    return context
}
